export enum FormType {
  CREATE = 'create',
  UPDATE = 'save',
}
